import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl mt-0 font-bold" }, "Tags", -1)
const _hoisted_3 = { class: "w-full flex flex-row overflow-x-auto" }

import { useCompany } from '@/store/company'
import { useSelectedProject } from '@/store/selectedProject'
import { alertController } from '@ionic/core'
import axios from 'axios'
import { IonChip, IonLabel, IonIcon, IonModal } from '@ionic/vue'
import { addCircle, closeCircle } from 'ionicons/icons'
import { ref } from 'vue'
import AddTagModal from './AddTagModal.vue'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'TagComponent',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const companyStore = useCompany()
const currentUserStore = useCurrentUser()

const modalIsOpen = ref(false)

async function deleteTagFromProject(tagId: string) {
  try {
    await axios.delete(process.env.VUE_APP_PROJECT_API_BASE_URL + 'project/' + selectedProjectStore.project._id + '/tag/' + tagId + "/?company=" + companyStore.activeCompany.id.toString(), {
      headers: {
        'Authorization': 'Bearer ' + currentUserStore.jwtKey
      }
    })
    const foundIndex = selectedProjectStore.project.tags.findIndex(tag => tag._id === tagId)
    selectedProjectStore.project.tags.splice(foundIndex, 1)
  } catch (e) {
    console.error(e)
    const alert = await alertController.create({
      message: "Fehlgeschlagen das Tag zu entfernen",
      buttons: ['OK']
    })
    await alert.present()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      onWillDismiss: _cache[0] || (_cache[0] = ($event: any) => (modalIsOpen.value = false)),
      "is-open": modalIsOpen.value,
      "presenting-element": _ctx.$parent!.$refs.ionRouterOutlet
    }, {
      default: _withCtx(() => [
        _createVNode(AddTagModal)
      ]),
      _: 1
    }, 8, ["is-open", "presenting-element"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(IonChip), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (modalIsOpen.value = true)),
          class: "ml-0 min-w-min"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), {
              class: "m-0",
              icon: _unref(addCircle)
            }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).project.tags, (tag) => {
          return (_openBlock(), _createBlock(_unref(IonChip), {
            class: "last:mr-0 min-w-min",
            key: tag._id,
            onClick: ($event: any) => (deleteTagFromProject(tag._id))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IonIcon), { icon: _unref(closeCircle) }, null, 8, ["icon"])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})